import React, { useState, useEffect, useRef, useContext} from 'react'
import './gazette.css'
import Sidebar from '../../components/Sidebar/Sidebar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown, faAngleUp, faArrowLeft, faArrowRight, faRotate } from '@fortawesome/free-solid-svg-icons'
import { Link,useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import * as Constants from '../../constants';
import BackLoader from '../../components/backloader'
import { ShareContext } from '../../context/ShareContext'



import { TextField,Button,Dialog ,DialogActions,DialogContent,DialogTitle } from '@mui/material'


function GazetteADR() {
    const {  profile } = useContext(ShareContext)
    const navigate = useNavigate();
    const {caseno} = useParams();
    const {paymode} = useParams();
    const {catid} = useParams();
    const {embed} = useParams(); //majorly motion
   // const {profileid}= useParams(); //'seniola1'
    const url= `${Constants.apiUrl}/gazette/adr/withcasedetails/${caseno}` ;//:`${Constants.apiUrl}/adr/gazette/bycategory/${catid}`;


//remove ****

// remove ****
var profileid=Constants.isServerEnv? Constants.getCookie("profilename"):'seniola1' ; // ;


    const [selectedRows, setSelectedRows] = useState(new Set());// 
    const [selectedItems, setSelectedItems] = useState({});
    const [selectedSigns, setSelectedSigns] = useState(new Set());
    const [selectedSignItems, setSelectedSignItems] = useState({});
    const [gazettes, setGazettes]=useState ([]);
    const [signs,setSigns]=useState([]);
    // const [collapse, setCollapse] = useState(false)
    const [collapsedCat, setCollapsedCat] = useState({})
    const [isLoading,setIsLoading]= useState(false);
    const [expandid, setExpandid] = useState(-1);

    const [category,setCategory]= useState({});
    const [inputqty, setInputQty] =useState([]);
    const [totalAmt, setTotalAmount]=useState(0);
    const scrollRef = useRef([]);
    const [activePrompt, setActivePrompt]= useState({open:false, activeId:0,numeric:1,bignumber:'', sp:{params:[]}});
    const [unspecAmount, setUnspecAmount] = useState ( {unspecamt1:'', unspecamt2:'', unspecamt3:'', unspecamt4:'', unspecamt5:''} );
    const [caseDetails , setCaseDetails]=useState( {} )
    const [source, setSource] =useState(null);

    const pams=new Set(Constants.DocPermissionList_ADR);

    const check = (id, row) => {
        console.log(`selected is ${id}`);
     //   console.log(row);
        const updatedSelectedRows = new Set(selectedRows);
        const updatedSelectedItems = { ...selectedItems };
      

        // Toggle the selection state for the clicked row
        if (updatedSelectedRows.has(id)) {
          
            if(pams.has(id)){
                //get total qty, if same with Judicial then remove the judicial item
                var ku=updatedSelectedItems[183];
                var mu=updatedSelectedItems[id];
                console.log(`ku.qty ${ku.qty}, ${mu.qty} *************************`)
                if(ku.qty>mu.qty){
                    const km=ku.qty-mu.qty;
                    updatedSelectedItems[183]={...ku,qty:km};
                }else{
                    //remove the item outrightly
                    updatedSelectedRows.delete(183);
                    delete updatedSelectedItems[183];
                    console.log('check at this point, 183 is removed **********');
                }
            }
            updatedSelectedRows.delete(id);
            delete updatedSelectedItems[id];
            removeUnspefiedValue(id); //will check if the id is on list and clear value
        
        } else {
          //  console.log('this is just added')
            updatedSelectedRows.add(id);
            updatedSelectedItems[id] = {...row, qty:1};

         //   console.log('this is checked and it supose to show now')
            const sp= specialList.filter((cat) => cat.id ==id);
                if(sp.length>0){
                 setActivePrompt({...activePrompt, open:true, id, sp:sp[0], title:row.itemDesc}); //this is to load the parts
                }

                if(pams.has(id)){
                    //this is the guy
                    //check if 717 already exist
                   if(updatedSelectedRows.has(183)){
                        //update with the value
                        //increase the qty
                        var r=updatedSelectedItems[183]
                        var vrow={...r,qty:r.qty+1};
                        updatedSelectedItems[183] = vrow;
                   } else{
                    //add the 183 item with it row
                        const xs=gazettes.filter((x)=>x.id==78);
                        const jud=xs[0].items.filter((k)=>k.itemSeqId==183);
                        updatedSelectedRows.add(183);
                        updatedSelectedItems[183] = {...jud[0], qty:1};
                   }
                 }
            
        }

        setSelectedRows(new Set(updatedSelectedRows));
        setSelectedItems(updatedSelectedItems);

       // console.log(updatedSelectedItems);
       onCalAmount(updatedSelectedItems, selectedSignItems);
    };

    const checkSign = (id, row) => {
        const updatedSelectedRows = new Set(selectedSigns);
        const updatedSelectedItems = { ...selectedSignItems };

        // Toggle the selection state for the clicked row
        if (updatedSelectedRows.has(id)) {
            updatedSelectedRows.delete(id);
            delete updatedSelectedItems[id];
        } else {
            updatedSelectedRows.add(id);
            updatedSelectedItems[id] = {...row, qty:1};
        }

        setSelectedSigns(new Set(updatedSelectedRows));
        setSelectedSignItems(updatedSelectedItems);
        onCalAmount(selectedItems,updatedSelectedItems);
    };

  
    const scrollToSection = id => {
        if (scrollRef.current.length) {
          scrollRef.current[id].scrollIntoView({behavior: 'smooth'});
        }
      };

    // console.log(selectedItems);

    const totalAmount = Object.values(selectedItems).reduce((sum, item) => sum + item.fee, 0)
    
    const clearItems = () => {
        onReset();
    } ;

    const goBack = () => {
        clearItems()

        navigate(-1)
    }

    function isObjectEmpty() {
        return Object.keys(selectedItems).length === 0 && selectedItems.constructor === Object;
    }
    function isSignEmpty() {
        return Object.keys(selectedSignItems).length === 0 && selectedSignItems.constructor === Object;
    }

    const proceedBtn= async()=>{
        //for account registration
        if (isObjectEmpty() && isSignEmpty()) {
            alert('Please pick items before proceeding');
            return;
        } 

        var rdata={childPayment: Object.values(selectedItems) ,feetypeid:paymode, casecatid:category.id,
            ...unspecAmount 
        };
        if(source!=null){
            //
            rdata.source=source;
        }
        console.log(JSON.stringify(rdata));
        try {
            setIsLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/gazette/adr/process/${caseno}/${profileid}`, {
              method: 'POST',
              body: JSON.stringify(rdata),
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            
            const responseData = await resp.json();
            setIsLoading(false);
            console.log(responseData);
            if (responseData.code === 0 ) {
                if(!responseData.isPaid){
                    window.location.replace(`${Constants.primarySite}/cms/specialredirect.aspx?casenumber=${responseData.casenumber}&casetype=adr&caseid=${caseno}`)
                }else{
                    navigate(`/upload/${responseData.casefeeid}`) //this is for already paid. That is for Ministry of Justice
                }
                
            }else {
             alert(responseData.status);
            }
          } catch (error) {
            setIsLoading(false);
            console.error(error);
           
          }
    }

    const toggleCollapse = (id) => {
        /* setCollapsedCat((prev) => ({
            ...prev,
            [id]: !prev[id]
        })) */
        console.info(`current id ${expandid} and newly selected ${id}`);
        setExpandid(id);
        
    }

    useEffect(() => {
        onLoadGazette()
       
      }, []);

      useEffect(() => {
        scrollToSection(expandid);
        console.log('ember value: '+embed)
        
        var em=Constants.getQuery();
        console.log('em query value: '+em)
        if(em!=null && em.trim()!=''){
            //var aa=atob(em);
            var aa=Constants.b64decode(em);
            var jso= JSON.parse(aa);
            setSource(jso);
            console.log(jso);
        }
        if(embed!=null){
            var aa=atob(embed);
            var jso= JSON.parse(aa);
            setSource(jso);
            console.log(jso);
        }
       
      }, [expandid]);
      const onLoadGazette= async()=>{
        //for account registration
      //  console.log(`the calling url ${url}`);
        try {
            setIsLoading(true);
            const resp = await fetch(url, { ///${paymode}/casetypeid?casetypeid=${casetypeid}
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'Authorization': '',
              },
            });
            
            const data = await resp.json();
            setIsLoading(false);
            console.log(data);
            if (data.code === 0) {
                var currentid=0;
                var gazlist=[];
                //buld dummy 
                data.childs.forEach(gaz => {
                 var idx=   gazlist.findIndex( function(el){return el.id==gaz.sectionId});
                 if(idx==-1){
                    //new specification
                    var idsp= data.parents.findIndex( function(el){return el.sectionId==gaz.sectionId});
                   
                    if(idsp==-1){
                      //  console.log('idsp index '+idsp);
                      //  console.log('cannot find specification for this one');
                      //  console.log(gaz)
                    }else{
                        var spobj={id:data.parents[idsp].sectionId, name:data.parents[idsp].sectionDesc, items:[]}
                    spobj.items.push( { ...gaz,qty:1});
                    gazlist.push(spobj);
                    }
                        
                    
                 }else{
                    gazlist[idx].items.push( { ...gaz,qty:1});
                 }

                });
                console.log('constructed dummy');
                console.log(gazlist)
                setGazettes(gazlist);
                setCaseDetails(data.casedetails);
                // if(catid==0){
                //     setCategory(Constants.CategoryList.filter((cat) => cat.id ==data.categoryid)[0])
                    
                // }
                    
                // else
                //     setCategory( Constants.CategoryList.filter((cat) => cat.id ==catid)[0])


          
            }else {    
            }
          } catch (error) {
            setIsLoading(false);
            console.error(error);
            
          }
    }
 
    const onQtyMain=(e,row,id)=>{
        const updatedItems = { ...selectedItems };
        const oldqty=updatedItems[id].qty;
        var vrow={...row,qty:e.target.value};
        updatedItems[id] = vrow;

       //for seal
              
              if(pams.has(id)){
                  console.log(`old value ${oldqty} and new value ${e.target.value}`)
              const qty=parseInt(e.target.value) - parseInt(oldqty)
              updatedItems[183].qty+=qty; //first remove old value, then add the new one
              }

      setSelectedItems(updatedItems);
       // console.log(vrow);
        onCalAmount(updatedItems, selectedSignItems);
    }

    const onQtySub=(e,row,id)=>{
        const updatedItems = { ...selectedSignItems };
       // const updatedSigns = { ...selectedSignItems };

       // setCardDetails({...cardDetails, [e.target.name]: e.target.value});
      // delete updatedSelectedItems[id];
      var vrow={...row,qty:e.target.value};
      updatedItems[id] = vrow;
      setSelectedSignItems(updatedItems);
       // console.log(vrow);
        onCalAmount(selectedItems,updatedItems);
    }

    const onCalAmount=(main, sub)=>{
        var mainAmt=0;
        var SubAmt=0;
      //  console.log('main item')
      //console.log(main);
      //console.log('sign item')
      //console.log(sub);
      //return;
      const arrMain=Object.values(main);
        for( const x of arrMain ){
           // console.log('in arrMain')
           // console.log(x);
            mainAmt+= (x.amount * x.qty);
        }
       const arrSub = Object.values(sub);
        for( const x of arrSub ){
            //console.log('in arrSub')
            //console.log(x);
            SubAmt+= (x.amount * x.qty);
        }
       
        setTotalAmount(mainAmt+SubAmt);
        console.log('Total amount calculated '+mainAmt+SubAmt);
    }

    const numricnote='Enter only numbers/figure and must be greater than zero';
    const specialList=[{id:6, msg:'How many of such Claim(s) are in this range?',params:[{placeholder:'value', warning:numricnote, type:'numeric'}]},
    {id:10, msg:'Interest(s) on how many claim(s)?',params:[{placeholder:'value',warning:numricnote, type:'numeric'}]},

    {id:14, msg:'How many of declaration(s)?',params:[{placeholder:'value',warning:numricnote, type:'numeric'}]},
    {id:25, msg:'How many of order(s)?',params:[{placeholder:'value',warning:numricnote, type:'numeric'}]},
   
    
    {id:7, msg:'How many of such Claim(s) are in this range?',params:[{placeholder:'value',warning:numricnote, type:'numeric'}]},
    {id:8, msg:'How many of such Claim(s) are in this range?',params:[{placeholder:'value',warning:numricnote, type:'numeric'}]},
    {id:9, msg:'How many of such Claim(s) are in this range?',params:[{placeholder:'value',warning:numricnote, type:'numeric'}]},
    {id:15, msg:'How many of order(s)?',params:[{placeholder:'value',warning:numricnote, type:'numeric'}]},
    {id:16, msg:'Maximum fee on how many claim(s)?',params:[{placeholder:'value',warning:numricnote, type:'numeric'}]},
    {id:17, msg:'Interest(s) on how many claim(s)?',params:[{placeholder:'value',warning:numricnote, type:'numeric'}]},

   
    {id:918, msg:'How many of such Claim(s) are in this range? ',params:[{placeholder:'value',warning:numricnote, type:'numeric'}]},
    {id:919, msg:'How many of such Claim(s) are in this range? ',params:[{placeholder:'value',warning:numricnote, type:'numeric'}]},
    {id:920, msg:'How many of such Claim(s) are in this range? ',params:[{placeholder:'value',warning:numricnote, type:'numeric'}]},
    {id:921, msg:'How many of such Claim(s) are in this range? ',params:[{placeholder:'value',warning:numricnote, type:'numeric'}]},
    {id:922, msg:'How many of such Claim(s) are in this range? ',params:[{placeholder:'value',warning:numricnote, type:'numeric'}]},
    {id:923, msg:'How many of such Claim(s) are in this range? ',params:[{placeholder:'value',warning:numricnote, type:'numeric'}]},
    {id:924, msg:'How many of such Claim(s) are in this range? ',params:[{placeholder:'value',warning:numricnote, type:'numeric'}]},
    {id:925, msg:'How many of such Claim(s) are in this range? ',params:[{placeholder:'value',warning:numricnote, type:'numeric'}]},
    {id:926, msg:'How many of such Claim(s) are in this range? ',params:[{placeholder:'value',warning:numricnote, type:'numeric'}]},
    {id:927, msg:'How many of such Claim(s) are in this range? ',params:[{placeholder:'value',warning:numricnote, type:'numeric'}]},
    {id:928, msg:'How many of such Claim(s) are in this range? ',params:[{placeholder:'value',warning:numricnote, type:'numeric'}]},
    {id:929, msg:'How many of such Claim(s) are in this range? ',params:[{placeholder:'value',warning:numricnote, type:'numeric'}]},
    {id:930, msg:'How many of such Claim(s) are in this range? ',params:[{placeholder:'value',warning:numricnote, type:'numeric'}]},
    {id:931, msg:'How many of such Claim(s) are in this range? ',params:[{placeholder:'value',warning:numricnote, type:'numeric'}]},
    {id:932, msg:'How many of such Claim(s) are in this range? ',params:[{placeholder:'value',warning:numricnote, type:'numeric'}]},
    {id:933, msg:'How many of such Claim(s) are in this range? ',params:[{placeholder:'value',warning:numricnote, type:'numeric'}]},
    {id:934, msg:'How many of such Claim(s) are in this range? ',params:[{placeholder:'value',warning:numricnote, type:'numeric'}]},
     {id:935, msg:'How many of such Claim(s) are in this range? ',params:[{placeholder:'value',warning:numricnote, type:'numeric'}]}, 

    {id:192, msg:'Please enter the sum to be recovered ',params:[{placeholder:'amount',warning:numricnote, type:'bignumber'},{placeholder:'How many of such Claim(s) are in this range?',warning:numricnote, type:'numeric'}]},
    {id:193, msg:'Please enter the sum to be recovered ',params:[{placeholder:'amount',warning:numricnote, type:'bignumber'},{placeholder:'How many of such Claim(s) are in this range?',warning:numricnote, type:'numeric'}]},    
    {id:194, msg:'Please enter the sum to be recovered ',params:[{placeholder:'amount',warning:numricnote, type:'bignumber'},{placeholder:'How many of such Claim(s) are in this range?',warning:numricnote, type:'numeric'}]},    
    {id:195, msg:'Please enter the sum to be recovered ',params:[{placeholder:'amount',warning:numricnote, type:'bignumber'},{placeholder:'How many of such Claim(s) are in this range?',warning:numricnote, type:'numeric'}]},    
    {id:178, msg:'Please enter the sum to be recovered ',params:[{placeholder:'amount',warning:numricnote, type:'bignumber'},{placeholder:'How many of such Claim(s) are in this range?',warning:numricnote, type:'numeric'}]},    
   
//737,739,740,741,742
    ]
   
    const onSaveActiveDialog=()=>{
        //save active
        console.log('onSaveActiveDialog starting')
        console.log(activePrompt);
        const updatedItems = { ...selectedItems };
        // const updatedSigns = { ...selectedSignItems };
        
        const id=activePrompt.id;
        const val=activePrompt.numeric;
        console.log(`activePrompt.activeId ${id} activePrompt.numeric ${val}`)
        
        // setCardDetails({...cardDetails, [e.target.name]: e.target.value});
       // delete updatedSelectedItems[id];
       var calfee=0;
       if(activePrompt.sp.params.length>1){
        //it contain big data
        //calculate big data
            var bignumber=activePrompt.bignumber;
            addUnspefiedValue(id,bignumber);

           
            calfee=Constants.CalUnSpecified(bignumber);
            console.log(`amount involved ${bignumber} translate to ${calfee}`)
        //end calculate big data
       }
       var row=updatedItems[id];
        console.log(row);
       var vrow= {...row,qty:val,amount: calfee>0?calfee:row.amount};
       updatedItems[id] = vrow;
       setSelectedItems(updatedItems);
         console.log(updatedItems);
         onCalAmount(updatedItems, selectedSignItems);

         setActivePrompt({open:false, activeId:0,numeric:1,bignumber:'', sp:{params:[]}})

    }
    const onCancelActiveDialog=()=>{
        setActivePrompt({...activePrompt,open:false, numeric:1, bignumber:''});
    }

    const onSetNumeric=(e)=>{
        var v=e.target.value;
        if(v<=0){
            v=1;
        }
        setActivePrompt({...activePrompt, numeric:v})
    }
    const onSetBigNumber=(e)=>{
        var v=e.target.value;
         if(isNaN(v))
            return; 

        //check if v is numeric and validate not below o
        if( v<=0){
            v='';
        }
        setActivePrompt({...activePrompt, bignumber:v})
    }

    const addUnspefiedValue = (id, amount)=>{
        //737,739,740,741,742
        //const [unspecAmount, setUnspecAmount] = useState ( {unsp1, unsp2, unsp3, unsp4, unsp5} );
        if(id==737){
            setUnspecAmount({...unspecAmount,unspecamt1:amount});
        }else if(id==739){
            setUnspecAmount({...unspecAmount,unspecamt2:amount});
        }
        else if(id==740){
            setUnspecAmount({...unspecAmount,unspecamt3:amount});
        }else if(id==741){
            setUnspecAmount({...unspecAmount,unspecamt4:amount});
        }else if(id==742){
            setUnspecAmount({...unspecAmount,unspecamt5:amount});
        }
    }

    const removeUnspefiedValue = (id)=>{
        if(id==737){
            setUnspecAmount({...unspecAmount,unspecamt1:''});
        }else if(id==739){
            setUnspecAmount({...unspecAmount,unspecamt2:''});
        }
        else if(id==740){
            setUnspecAmount({...unspecAmount,unspecamt3:''});
        }else if(id==741){
            setUnspecAmount({...unspecAmount,unspecamt4:''});
        }else if(id==742){
            setUnspecAmount({...unspecAmount,unspecamt5:''});
        }
    }

    const onReset=()=>{
        setSelectedRows(new Set()); setSelectedItems({}); setSelectedSigns(new Set()); setSelectedSignItems({});setTotalAmount(0);
        setUnspecAmount( {unspecamt1:'', unspecamt2:'', unspecamt3:'', unspecamt4:'', unspecamt5:''} );
    }

  return (
    <div className='gazette-list'>
        <Sidebar />
        <div className="body">
            <div className="top-nav">
                <div className="left-top">
                    <div className="top">
                        <h2>{caseDetails.caseNumber} | ADR Case</h2>
                        {/* <button><Link to={`/categories/${caseno}/${paymode}`}>Change Category</Link></button> */}
                    </div>
                    <p>Select items related to the case that you are filing</p>
                </div>
                <p className="nav-status">Home/Specifications</p>
            </div>
            <div className="table-container">
                <table>
                    <thead>
                        <tr>
                            <th colSpan='2'>Select Specification</th>
                           
                            <th>Document Required</th>
                            <th>Document Quantity</th>
                        </tr>
                    </thead>
                    {gazettes.length>0 &&
                        gazettes.map((item, id) => { return (
                            <tbody key={id} className={expandid!=item.id ? 'collapse' : ''} ref={ref => (scrollRef.current[item.id] = ref)}>
                                <tr>
                                    <td className='span' colSpan='3'>
                                        {item.name} 
                                    </td>
                                    <td className='span'>
                                        <div className="icon" onClick={() => toggleCollapse(item.id)}>
                                            <FontAwesomeIcon icon={expandid==item.id ? faAngleDown : faAngleUp } />
                                        </div>
                                    </td>
                                </tr>   
                                {
                                    item.items.map((row, idx) => { return (
                                        <tr className={selectedRows.has(row.itemSeqId) ? 'specific-row picked' : 'specific-row'} key={idx}>
                                            <td>
                                                {Constants.NoteExcept(row.itemDesc)?'': <input 
                                                    type="checkbox" 
                                                    className='check'
                                                    id={row.itemSeqId}
                                                    onClick={() => check(row.itemSeqId, row)}
                                                    defaultChecked={selectedRows.has(row.itemSeqId)}
                                                    checked={selectedRows.has(row.itemSeqId)}
                                                    disabled={row.itemSeqId==183}
                                                />}
                                               
                                            </td>
                                           {Constants.NoteExcept(row.itemDesc)?
                                           <td className='specification' style={{color:'red', fontWeight:'bold'}}>{row.itemDesc}  </td>:
                                           <td className='specification'>{row.itemDesc} {row.itemType=='External'?'':'***'}  </td>
                                        } 
                                            <td className='document-upload'>
                                                {row.isUploadRequire ? <p>Document Required</p> : ''}
                                            </td>
                                            <td className='quantity'>
                                                {
                                                    (!Constants.NoteExcept(row.itemDesc)) ? <input type="number" className='number' min={1} value={selectedItems[row.itemSeqId]?.qty==undefined?1:selectedItems[row.itemSeqId]?.qty} onChange={(e)=>onQtyMain(e,row,row.itemSeqId)} id='numOfdocs' disabled={!selectedRows.has(row.itemSeqId) || row.itemSeqId==183}/> : ''
                                                }
                                            </td>
                                        </tr>
                                    )})
                                }
                            </tbody>
                        )})
                    }
                </table>
            </div>
           
            <div className="total-pay">
                <div className="reset-back">
                    <div className="back" onClick={() => goBack()}>
                        <FontAwesomeIcon icon={faArrowLeft} />
                        <p>Back</p>
                    </div>
                    <button onClick={() => clearItems()}>Reset Selection <FontAwesomeIcon icon={faRotate} /></button>
                </div>
                <div className="total-fee">
                    {/* <p className="total">Total Fee (₦): <span>{totalAmount}</span></p> */}
                    <h2 className='amount-after'>Total Fee{/*  (₦) */}: <span>{profile?.gov==true?0: Constants.formatCurrency(totalAmt)}</span></h2>
                    <button onClick={() => proceedBtn()}>Proceed <FontAwesomeIcon icon={faArrowRight} /></button>
                </div>
            </div>
        </div>
        <BackLoader open={isLoading}  />
           
        {activePrompt.open && <div className={ "dialog-box open" }>
                    
                   
                        <div className="wrapper">
                        <h3>{activePrompt.title}</h3>
                        <div className="main">
                            <p>{activePrompt.sp.msg}</p>
                            <div style={{marginTop:16}}>
                                {activePrompt.sp.params.length==1 && <div>
                                
                                    <TextField id="outlined-basic" label="Qty" variant="outlined" type="number"  
                                    value={activePrompt.numeric} onChange={onSetNumeric} min={1}  helperText={numricnote}  />
                                
                                    </div>}
                                    {activePrompt.sp.params.length==2 && <div>
                                    

                                    <TextField id="outlined-basic" label="Amount" variant="outlined"  
                                    value={activePrompt.bignumber} onChange={onSetBigNumber} min={1} helperText={numricnote}  />
                                    <div style={{margin:16}}>
                                    <strong>{activePrompt.sp.params[1].placeholder}</strong>
                                    </div>
                                    <TextField id="outlined-basic" label="Qty" variant="outlined" type="number"  
                                    value={activePrompt.numeric} onChange={onSetNumeric} min={1} helperText={numricnote}  />
                                    
                                    </div>}
                            </div>
                            <div className="btns">
                                <button onClick={onCancelActiveDialog} className='red'>Cancel</button>
                                <button className='red' onClick={onSaveActiveDialog}>Ok <FontAwesomeIcon icon={faArrowRight} /></button>
                            </div>  
                        </div>
                    </div>
                    
                    
                </div>}
    </div>
  )
}

export default GazetteADR